import { createContext } from 'react';
import { DiceJobsContextType } from '../types';

const DiceJobsContext = createContext<DiceJobsContextType>({
  diceSearch: null,
  setDiceSearch: () => {},
});

export default DiceJobsContext;
